import { useEffect } from 'react';
import { CheckCircle2, AlertCircle, Info, AlertTriangle, X } from 'lucide-react';
import { useUiStore, type Notification } from '@/store/ui.store';
import { cn } from '@/lib/cn';

const icons = {
  success: CheckCircle2,
  error: AlertCircle,
  info: Info,
  warning: AlertTriangle,
} as const;

const accents = {
  success: 'text-green-500',
  error: 'text-red-500',
  info: 'text-sky-500',
  warning: 'text-amber-500',
} as const;

function ToastItem({ n }: { n: Notification }) {
  const dismiss = useUiStore((s) => s.dismiss);
  const Icon = icons[n.variant];

  useEffect(() => {
    const t = setTimeout(() => dismiss(n.id), 4500);
    return () => clearTimeout(t);
  }, [n.id, dismiss]);

  return (
    <div
      className={cn(
        // 21-oct, macOS 27: notificación en vidrio, radio 19.
        'mac-hoja pointer-events-auto flex w-80 max-w-[calc(100vw-32px)] items-start gap-3 rounded-[19px] px-3.5 py-3 ' +
          'animate-slide-in',
      )}
      role="status"
    >
      <Icon className={cn('mt-0.5 h-5 w-5 shrink-0', accents[n.variant])} />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium text-slate-900 dark:text-slate-100">{n.title}</p>
        {n.description && <p className="mt-0.5 text-sm text-slate-500 dark:text-slate-400">{n.description}</p>}
      </div>
      <button
        onClick={() => dismiss(n.id)}
        className="-m-2.5 grid h-11 w-11 shrink-0 place-items-center text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 lateral:m-0 lateral:h-5 lateral:w-5"
        aria-label="Cerrar"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}

/** Contenedor global de toasts. Montar una vez en la raíz de la app. */
export function ToastProvider() {
  const notifications = useUiStore((s) => s.notifications);
  return (
    <div className="pointer-events-none fixed inset-x-4 bottom-4 z-[60] flex flex-col items-center gap-2 pb-[env(safe-area-inset-bottom)] lateral:inset-x-auto lateral:right-4 lateral:items-end">
      {notifications.map((n) => (
        <ToastItem key={n.id} n={n} />
      ))}
    </div>
  );
}
